<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import draggable from 'vuedraggable'

const formkitProps = defineProps<{
  context: FormKitFrameworkContext
}>()
const context = formkitProps.context
</script>
<template>
  <div>
    <draggable :v-model="context.value" item-key="id">
      <template #item="{ element, index }">
        <div>
          {{ element }} {{ index }}
          <slot />
        </div>
      </template>
    </draggable>
  </div>
</template>
